import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";

// Lazy load non-critical routes
const Solutions = lazy(() => import("./pages/Solutions"));
const WhoWeWorkWith = lazy(() => import("./pages/WhoWeWorkWith"));
const HowWeWork = lazy(() => import("./pages/HowWeWork"));
const Insights = lazy(() => import("./pages/Insights"));
const About = lazy(() => import("./pages/About"));
const RequestAssessment = lazy(() => import("./pages/RequestAssessment"));
const AIReadinessChecklist = lazy(() => import("./pages/AIReadinessChecklist"));
const Contact = lazy(() => import("./pages/Contact"));
const NotFound = lazy(() => import("./pages/NotFound"));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-pulse text-muted-foreground">Loading...</div>
  </div>
);

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/solutions" element={<Suspense fallback={<PageLoader />}><Solutions /></Suspense>} />
          <Route path="/who-we-work-with" element={<Suspense fallback={<PageLoader />}><WhoWeWorkWith /></Suspense>} />
          <Route path="/how-we-work" element={<Suspense fallback={<PageLoader />}><HowWeWork /></Suspense>} />
          <Route path="/insights" element={<Suspense fallback={<PageLoader />}><Insights /></Suspense>} />
          <Route path="/about" element={<Suspense fallback={<PageLoader />}><About /></Suspense>} />
          <Route path="/request-assessment" element={<Suspense fallback={<PageLoader />}><RequestAssessment /></Suspense>} />
          <Route path="/ai-readiness-checklist" element={<Suspense fallback={<PageLoader />}><AIReadinessChecklist /></Suspense>} />
          <Route path="/contact" element={<Suspense fallback={<PageLoader />}><Contact /></Suspense>} />
          <Route path="*" element={<Suspense fallback={<PageLoader />}><NotFound /></Suspense>} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
